import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDeY2LVgKOycyzrYebyeINtquq6tH2w_Ck",
  authDomain: "metazicians-app.firebaseapp.com",
  projectId: "metazicians-app",
  storageBucket: "metazicians-app.firebasestorage.app",
  messagingSenderId: "326895180626",
  appId: "1:326895180626:web:6fdabc7b2c66b51226388b"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

// Force account selection and improve user experience
googleProvider.setCustomParameters({
  prompt: 'select_account',  // Always show account picker
  hd: '',                    // Allow any domain (remove if you want to restrict to specific domains)
});

// signInWithPopup is especially prone to a handful of environment-specific
// failures on mobile browsers (the popup gets blocked, the user backgrounds
// the tab mid-flow, or the page is loaded inside an in-app webview that
// doesn't support window.open at all) - raising err.message straight from
// Firebase in those cases shows something like
// "Firebase: Error (auth/popup-blocked)." instead of an explanation a user
// can act on. This only changes the displayed text, not any auth control
// flow.
function googleSignInErrorMessage(err) {
  switch (err?.code) {
    case 'auth/popup-blocked':
      return "Your browser blocked the Google sign-in popup. Please allow popups for this site and try again.";
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
      return "Google sign-in was closed before it finished. Please try again.";
    case 'auth/unauthorized-domain':
      return "Google sign-in isn't available from this address yet. Please try again later.";
    case 'auth/operation-not-supported-in-this-environment':
      return "Google sign-in isn't supported in this browser. Try opening the site in Safari or Chrome instead of an in-app browser.";
    case 'auth/network-request-failed':
      return "Network error during Google sign-in. Check your connection and try again.";
    case 'permission-denied':
      return "We couldn't finish setting up your account due to a permissions issue on our end. Please try signing in again, and contact support if this keeps happening.";
    default:
      return err?.message || "Google sign-in failed. Please try again.";
  }
}

export { auth, db, googleProvider, googleSignInErrorMessage };